import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'output'),
  uk: createLocale(uk, 'output'),
  pl: createLocale(pl, 'output'),
  ru: createLocale(ru, 'output'),
  es: createLocale(es, 'output'),
  uz: createLocale(uz, 'output'),
  hi: createLocale(hi, 'output'),
};

export default locales;
